import styled from 'styled-components';

const AmtContainer = styled.div`
  width: 12rem;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default AmtContainer;
